import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'

const client = new ApiClient(API_NAME)

export default {
  get(query) {
    return client.get(`/use-history`, query)
  }
}
